<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card mb-4">
          <div class="card-header pb-0 d-flex justify-content-between">
            <h6>Nueva actividad</h6>
          </div>
          <div class="card-body">
            <div class="col-sm mx-60">
              <form @submit.prevent="handleSubmit">
                <div class="row">
                  <div class="col-md-6">
                    <label class="form-control-label"> Nombre </label>
                    <input
                      v-model="newActivity.name"
                      :class="[
                        'form-control',
                        v.name.$error ? 'is-invalid' : '',
                      ]"
                      type="text"
                      placeholder=""
                    />
                    <p v-if="v.name.$error" class="invalid-feedback mb-0">
                      <small>
                        {{ v.name.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label">Tipo</label>
                    <select
                      v-model="newActivity.activityType"
                      :class="[
                        'form-select',
                        v.activityType.$error ? 'is-invalid' : '',
                      ]"
                    >
                      <option
                        v-for="selectItem in activityTypes"
                        :key="selectItem['@id']"
                        :value="selectItem['@id']"
                      >
                        {{ selectItem.name }}
                      </option>
                    </select>
                    <p
                      v-if="v.activityType.$error"
                      class="invalid-feedback mb-0"
                    >
                      <small>
                        {{ v.activityType.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label">Temática</label>
                    <select
                      v-model="newActivity.activityThematic"
                      class="form-select"
                    >
                      <option
                        v-for="selectItem in activityThematics"
                        :key="selectItem['@id']"
                        :value="selectItem['@id']"
                      >
                        {{ selectItem.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-6">
                    <label class="form-control-label"> Subtítulo </label>
                    <textarea
                      v-model="newActivity.subtitle"
                      class="form-control"
                      rows="4"
                    />
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label"> Descripción </label>
                    <textarea
                      v-model="newActivity.description"
                      :class="[
                        'form-control',
                        v.description.$error ? 'is-invalid' : '',
                      ]"
                      rows="4"
                    />
                    <p
                      v-if="v.description.$error"
                      class="invalid-feedback mb-0"
                    >
                      <small>
                        {{ v.description.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-3">
                    <label class="form-control-label"> Código </label>
                    <input
                      v-model="newActivity.code"
                      class="form-control"
                      type="text"
                      min="0"
                    />
                  </div>
                  <div class="col-md-1">
                    <label class="form-control-label"> Aforo </label>
                    <input
                      v-model="newActivity.capacity"
                      class="form-control"
                      type="number"
                      min="-1"
                    />
                  </div>
                  <div class="col-md-2">
                    <label class="form-control-label"> Duración </label>
                    <input
                      v-model="newActivity.duration"
                      class="form-control"
                      type="text"
                      min="0"
                    />
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label"> Fecha </label>
                    <input
                      v-model="newActivity.date"
                      :class="[
                        'form-control',
                        v.date.$error ? 'is-invalid' : '',
                      ]"
                      type="datetime-local"
                      placeholder=""
                    />
                    <p v-if="v.date.$error" class="invalid-feedback mb-0">
                      <small>
                        {{ v.date.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label"> Idioma </label>
                    <input
                      v-model="newActivity.language"
                      class="form-control"
                      type="text"
                      min="0"
                    />
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-6">
                    <label class="form-control-label"> Organizado por </label>
                    <input
                      v-model="newActivity.organizer"
                      :class="[
                        'form-control',
                        v.organizer.$error ? 'is-invalid' : '',
                      ]"
                      type="text"
                    />
                    <p v-if="v.organizer.$error" class="invalid-feedback mb-0">
                      <small>
                        {{ v.organizer.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                  <div class="col-md-6">
                    <label class="form-control-label"> Audiencia </label>
                    <select
                      v-model="newActivity.ageLimit"
                      :class="[
                        'form-select',
                        v.ageLimit.$error ? 'is-invalid' : '',
                      ]"
                    >
                      <option
                        key="Recomendada para adolescentes: de 16 a 18 años"
                        value="Recomendada para adolescentes: de 16 a 18 años"
                      >
                        Recomendada para adolescentes: de 16 a 18 años
                      </option>
                      <option
                        key="Recomendada para jóvenes de más de 25 años"
                        value="Recomendada para jóvenes de más de 25 años"
                      >
                        Recomendada para jóvenes de más de 25 años
                      </option>
                      <option
                        key="Para mayores de 18 años"
                        value="Para mayores de 18 años"
                      >
                        Para mayores de 18 años
                      </option>
                      <option
                        key="Recomendada para todos los públicos"
                        value="Recomendada para todos los públicos"
                      >
                        Recomendada para todos los públicos
                      </option>
                    </select>
                    <p v-if="v.ageLimit.$error" class="invalid-feedback mb-0">
                      <small>
                        {{ v.ageLimit.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-6">
                    <label class="form-control-label"> Dirección </label>
                    <input
                      ref="streetRef"
                      v-model="newActivity.address"
                      :class="[
                        'form-control',
                        v.address.$error ? 'is-invalid' : '',
                      ]"
                      type="text"
                    />
                    <p v-if="v.address.$error" class="invalid-feedback mb-0">
                      <small>
                        {{ v.address.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label"> Latitud </label>
                    <input
                      v-model="newActivity.latitude"
                      :class="[
                        'form-control',
                        v.latitude.$error ? 'is-invalid' : '',
                      ]"
                      type="text"
                      placeholder=""
                    />
                    <p v-if="v.latitude.$error" class="invalid-feedback mb-0">
                      <small>
                        {{ v.latitude.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label"> Longitud </label>
                    <input
                      v-model="newActivity.longitude"
                      :class="[
                        'form-control',
                        v.longitude.$error ? 'is-invalid' : '',
                      ]"
                      type="text"
                      placeholder=""
                    />
                    <p v-if="v.longitude.$error" class="invalid-feedback mb-0">
                      <small>
                        {{ v.longitude.$errors[0].$message }}
                      </small>
                    </p>
                  </div>
                </div>
                <div
                  ref="mapDiv"
                  class="mt-4"
                  style="width: 100%; height: 50vh"
                />
                <div class="mt-3">
                  <button
                    type="submit"
                    class="
                      float-end
                      btn btn-primary
                      text-white
                      bg-blue-600
                      rounded-lg
                      border border-primary
                      hover:bg-blue-900
                    "
                  >
                    Guardar
                  </button>
                  <button
                    class="
                      me-2
                      float-end
                      btn btn-primary
                      text-danger
                      bg-white
                      border border-danger
                      rounded-lg
                      hover:bg-blue-900
                    "
                    @click="handleCancel"
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

import { Loader } from "@googlemaps/js-api-loader";

const GOOGLE_MAPS_API_KEY = "AIzaSyDCiyEwDxu5Ts3ktGPqPq3SNIgh8K7i93M";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const mapDiv = ref(null);
    const streetRef = ref(null);
    const activityThematics = ref(null);

    const loader = new Loader({
      apiKey: GOOGLE_MAPS_API_KEY,
      version: "weekly",
      libraries: ["places"],
    });

    const newActivity = ref({
      name: "",
      description: "",
      address: "",
      organizer: "",
      ageLimit: "",
      date: "",
      activityType: "",
      latitude: "",
      longitude: "",
      activityThematic: null,
    });

    const rules = computed(() => {
      return {
        name: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
        description: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
        address: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
        organizer: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
        ageLimit: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
        date: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
        activityType: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
        latitude: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
        longitude: {
          required: helpers.withMessage("Este campo es obligatorio", required),
        },
      };
    });

    onMounted(async () => {
      await loader.load();

      const map = new google.maps.Map(mapDiv.value, {
        center: { lat: 40.971987985427404, lng: -5.663032738304067 },
        zoom: 15,
      });

      const autocomplete = new google.maps.places.SearchBox(streetRef.value);

      let markers = [];

      autocomplete.addListener("places_changed", () => {
        const places = autocomplete.getPlaces();

        if (places.length === 0) {
          return;
        }

        // Clear out the old markers
        markers.forEach((marker) => {
          marker.setMap(null);
        });
        markers = [];

        const place = places[0];

        newActivity.value.address = place.formatted_address;

        newActivity.value.latitude = place.geometry.location.lat().toString();
        newActivity.value.longitude = place.geometry.location.lng().toString();

        map.setCenter(place.geometry.location);

        markers.push(
          new google.maps.Marker({
            map,
            title: place.name,
            position: new google.maps.LatLng(
              place.geometry.location.lat(),
              place.geometry.location.lng()
            ),
          })
        );
      });
    });

    onMounted(() => store.dispatch("activity/getActivityTypes"));

    watch(
      () => newActivity.value.activityType,
      () => {
        if (newActivity.value.activityType !== null) {
          let activityThematic = activityTypes.value.find(
            (activityType) =>
              activityType["@id"] === newActivity.value.activityType
          );

          if (activityThematic !== undefined) {
            activityThematics.value = activityThematic.activityThematics;
          }
        }
      }
    );

    const activityTypes = computed(
      () => store.getters["activity/getActivityTypes"]
    );

    const v$ = useVuelidate(rules, newActivity);
    const v = v$.value;

    const handleSubmit = () => {
      v$.value.$validate();
      if (!v$.value.$invalid) {
        createActivity(newActivity.value);
      }
    };

    const handleCancel = () => {
      router.push({ name: "Actividades", params: {} });
    };

    const createActivity = async (activity) => {
      try {
        await store.dispatch("activity/add", activity);
        await router.push({ name: "Actividades", params: {} });
      } catch (error) {
        console.log(error);
      }
    };

    return {
      activityTypes,
      newActivity,
      handleSubmit,
      v,
      handleCancel,
      mapDiv,
      streetRef,
      activityThematics,
    };
  },
};
</script>
